const Routes = Object.freeze({
  DASHBOARD: '/',
  RESIDENT_ONBOARDING: '/resident-onboarding',
  VENDOR_ONBOARDING: '/vendor-onboarding',
  ADMIN_BUILDINGS: '/admin-dashboard/buildings',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_EMAIL: '/confirm-email',
  PAYMENT_SELECT: '/payment-select',
  DATA_TABLE: '/data-table',
  INPUTS: '/inputs',
  SANDBOX: '/sandbox',
  EMAIL_TEMPLATE: '/email-template',
  PASSWORD_CHANGED_CONFIRMATION: '/password-changed',
  EMAIL_CHANGED_CONFIRMATION: '/email-changed',
} as const);

export default Routes;

export type AvailableRoutes = (typeof Routes)[keyof typeof Routes];
